import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

export interface ConfigData {
    baseApiUrl: string;
  }
 
@Injectable({ providedIn: "root" })
export class ConfigService {
  private configData: ConfigData;

  constructor(private http: HttpClient) {}

  loadConfigData() {
    return this.http
      .get("/config.json")
      .toPromise()
      .then(data => {
        this.configData = JSON.parse(JSON.stringify(data));
      });
  }

  getConfigBaseApiUrl() {
    if (!this.configData) {
      throw Error("Error loading configuration file.");
    }
    return this.configData.baseApiUrl;
  }
}